import { useState } from 'react';
import { Dialog, DialogContent } from '@/components/ui/dialog';
import { X } from 'lucide-react';

const galleryItems = [
  {
    id: 1,
    title: 'Mešano meso z žara',
    category: 'food',
    imageSrc: 'https://images.unsplash.com/photo-1555939594-58d7cb561ad1?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
  },
  {
    id: 2,
    title: 'BBQ rebra',
    category: 'food',
    imageSrc: 'https://images.unsplash.com/photo-1529193591184-b1d58069ecdd?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
  },
  {
    id: 3,
    title: 'Ambient bara',
    category: 'interior',
    imageSrc: 'https://images.unsplash.com/photo-1514933651103-005eec06c04b?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
  },
  {
    id: 4,
    title: 'Craft pivo',
    category: 'drinks',
    imageSrc: 'https://images.unsplash.com/photo-1566633806327-68e152aaf26d?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
  },
  {
    id: 5,
    title: 'Selekcija vin',
    category: 'drinks',
    imageSrc: 'https://images.unsplash.com/photo-1510812431401-41d2bd2722f3?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
  },
  {
    id: 6,
    title: 'Žar mojster',
    category: 'staff',
    imageSrc: 'https://images.unsplash.com/photo-1530632789071-8543f47edb34?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
  },
  {
    id: 7,
    title: 'Zunanji ambient',
    category: 'interior',
    imageSrc: 'https://images.unsplash.com/photo-1555396273-367ea4eb4db5?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
  },
  {
    id: 8,
    title: 'Postrežba pijač',
    category: 'drinks',
    imageSrc: 'https://images.unsplash.com/photo-1470337458703-46ad1756a187?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
  },
];

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const [selectedTitle, setSelectedTitle] = useState<string | null>(null);
  const [filter, setFilter] = useState<string>('all');

  const filteredItems = filter === 'all' 
    ? galleryItems 
    : galleryItems.filter(item => item.category === filter);

  const openImage = (imageSrc: string, title: string) => {
    setSelectedImage(imageSrc);
    setSelectedTitle(title);
  };

  const closeImage = () => {
    setSelectedImage(null);
    setSelectedTitle(null);
  };

  return (
    <section className="section-container" id="gallery">
      <div className="text-center max-w-3xl mx-auto mb-12 animate-fade-in">
        <div className="inline-flex items-center space-x-2 mb-4">
          <div className="h-px w-8 bg-barbecue-500"></div>
          <span className="text-barbecue-500 font-medium">GALERIJA</span>
          <div className="h-px w-8 bg-barbecue-500"></div>
        </div>
        <h2 className="heading-lg mb-4">Vtisi s Polskave</h2>
        <p className="paragraph">
          Oglejte si fotografije naših kulinaričnih stvaritev, 
          prijetnega ambienta in dogodkov pri nas.
        </p>
      </div>

      {/* Filter */}
      <div className="flex justify-center mb-8">
        <div className="flex overflow-x-auto space-x-2 pb-2">
          <button
            onClick={() => setFilter('all')}
            className={`px-4 py-2 rounded-full text-sm transition-colors ${
              filter === 'all'
                ? 'bg-barbecue-600 text-white'
                : 'bg-muted text-foreground hover:bg-barbecue-100'
            }`}
          >
            Vse
          </button>
          <button
            onClick={() => setFilter('food')}
            className={`px-4 py-2 rounded-full text-sm transition-colors ${
              filter === 'food'
                ? 'bg-barbecue-600 text-white'
                : 'bg-muted text-foreground hover:bg-barbecue-100'
            }`}
          >
            Hrana
          </button>
          <button
            onClick={() => setFilter('drinks')}
            className={`px-4 py-2 rounded-full text-sm transition-colors ${
              filter === 'drinks'
                ? 'bg-barbecue-600 text-white'
                : 'bg-muted text-foreground hover:bg-barbecue-100'
            }`}
          >
            Pijača
          </button>
          <button
            onClick={() => setFilter('interior')}
            className={`px-4 py-2 rounded-full text-sm transition-colors ${
              filter === 'interior'
                ? 'bg-barbecue-600 text-white'
                : 'bg-muted text-foreground hover:bg-barbecue-100'
            }`}
          >
            Ambient
          </button>
          <button
            onClick={() => setFilter('staff')}
            className={`px-4 py-2 rounded-full text-sm transition-colors ${
              filter === 'staff'
                ? 'bg-barbecue-600 text-white'
                : 'bg-muted text-foreground hover:bg-barbecue-100'
            }`}
          >
            Osebje
          </button>
        </div>
      </div>

      {/* Gallery Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {filteredItems.map((item) => (
          <div 
            key={item.id} 
            className="gallery-item cursor-pointer animate-scale-in" 
            onClick={() => openImage(item.imageSrc, item.title)}
          >
            <img 
              src={item.imageSrc} 
              alt={item.title} 
              className="w-full h-64 object-cover" 
            />
            <div className="gallery-overlay">
              <h3 className="text-white font-medium">{item.title}</h3>
            </div>
          </div>
        ))}
      </div>

      {/* Lightbox Dialog - Fixed implementation */}
      {selectedImage && (
        <Dialog open={!!selectedImage} onOpenChange={closeImage}>
          <DialogContent 
            className="max-w-4xl p-0 bg-transparent border-none"
          >
            <button 
              onClick={closeImage}
              className="absolute top-2 right-2 z-50 text-white p-2 rounded-full bg-black/50 hover:bg-black/70 transition-colors cursor-pointer"
              aria-label="Close dialog"
            >
              <X className="h-5 w-5" />
            </button>
            
            <div className="max-w-4xl w-full max-h-[90vh] relative">
              <img 
                src={selectedImage} 
                alt={selectedTitle || 'Gallery image'} 
                className="w-full h-auto max-h-[90vh] object-contain" 
              />
              {selectedTitle && (
                <div className="absolute bottom-0 left-0 right-0 bg-black/60 p-4 text-white">
                  <h3 className="text-xl font-medium">{selectedTitle}</h3>
                </div>
              )}
            </div>
          </DialogContent>
        </Dialog>
      )}
    </section>
  );
};

export default Gallery;